import React, { useState } from "react";
import styles from "./EditBlogTab.module.scss";
import { updateBlogPost } from "../../../../../ApiLayer/admin";
import BlogEditor from "../BlogEditor/BlogEditor";
import SelectABlogPost from "../SelectABlogPost/SelectABlogPost";
import MessageComponent from "../../../../../Components/MessageComponent/MessageComponent";
import ConfirmPopup from "../../../../../Components/ConfirmPopupComponent/ConfirmPopup";

const EditBlogTab = () => {
  const [message, setMessage] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [updateData, setUpdateData] = useState(null);

  const handlePostSelect = (post) => {
    setSelectedPost(post);
  };

  const handleUpdate = async (data) => {
    if (!selectedPost) {
      setMessage("Please select a post to update");
      return;
    }

    if (!data.title.trim()) {
      setMessage("Please enter a title for your blog post");
      return;
    }

    setUpdateData(data);
    setShowConfirmPopup(true);
  };

  const confirmUpdate = async () => {
    setIsSaving(true);
    try {
      const response = await updateBlogPost({
        oldTitle: selectedPost.title,
        newTitle: updateData.title.trim(),
        content: updateData.content,
        category: updateData.category,
      });

      if (!response.success) {
        setMessage(
          response.message || "Error updating blog post. Please try again."
        );
        return;
      }

      setMessage("Blog post updated successfully!");
      setSelectedPost(null);
    } catch (error) {
      console.error("Error updating blog post:", error);
      setMessage("Error updating blog post. Please try again.");
    } finally {
      setIsSaving(false);
      setShowConfirmPopup(false);
      setUpdateData(null);
    }
  };

  return (
    <>
      <div className={styles.tabContent}>
        <div className={styles.stagingHeader}>
          <h2>Edit Blog Post</h2>
          <p>Select a post to edit and update its content.</p>
        </div>
        <MessageComponent message={message} />
        <div className={styles.selectContainer}>
          <SelectABlogPost onPostSelect={handlePostSelect} />
        </div>
      </div>
      {selectedPost && (
        <BlogEditor
          key={selectedPost?._id}
          initialTitle={selectedPost.title}
          initialContent={selectedPost.content}
          initialCategory={selectedPost.category}
          onSave={handleUpdate}
          isSaving={isSaving}
          buttonText="Update Post"
        />
      )}
      <ConfirmPopup
        isOpen={showConfirmPopup}
        onClose={() => setShowConfirmPopup(false)}
        onConfirm={confirmUpdate}
        title="Confirm Update"
        message="Are you sure you want to update this blog post? This action cannot be undone."
        confirmText="Update Post"
        cancelText="Cancel"
      />
    </>
  );
};

export default EditBlogTab;
